import React from "react";
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import CallToActionButton from "../components/common/components/callToActionButton";
import { StaticImage } from "gatsby-plugin-image";

const Topbar = () => {
    const { t } = useTranslation();

    return(
        <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNavSubPage">
            <div className="logo-margin">
                <img alt="Gambit Logo Light" loading="lazy" src="/images/GambitLabCompletpLight.png" />
            </div>
            <button className="navbar-toggler navbar-toggler-right mx-3" type="button" data-bs-theme="dark" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <i className="bi bi-list" style={{"color": "#08a1de", "font-size": "25px"}}></i>
            </button>

            <div className="collapse navbar-collapse" id="navbarResponsive">
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item" id="hover-effect"><Link to="/" className="nav-link text-center" dangerouslySetInnerHTML={{__html: t("topbar-home")}}></Link></li>
                    <li className="nav-item" id="hover-effect"><Link to="/web-development" className="nav-link text-center" dangerouslySetInnerHTML={{__html: t("topbar-webapps")}}></Link></li>
                    <li className="nav-item" id="hover-effect"><Link to="/app-development" className="nav-link text-center" dangerouslySetInnerHTML={{__html: t("topbar-mobileapps")}}></Link></li>
                    <li className="nav-item" id="hover-effect"><Link to="/xr" className="nav-link text-center" dangerouslySetInnerHTML={{__html: t("topbar-vr")}}></Link></li>
                    <li className="nav-item" style={{"display": "flex", "align-items": "center", "justify-content": "center", paddingInline: '1rem'}}>
                        <CallToActionButton text={t("topbar-call-to-action")} color="black" />
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Topbar;